import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {ApiCallOptions, PaginatedResponse} from '../types/api';
import type {
    ContactResource,
    SearchContactsParams,
    ListContactsParams,
    CreateContactRequest,
    UpdateContactRequest
} from './api.d';

export const contactApi = {
    searchContacts: (
        accountUserId: string,
        params: SearchContactsParams,
        options?: ApiCallOptions
    ) => createApiCall<PaginatedResponse<ContactResource>>(
        SERVICE_NAMES.CONTACT,
        'GET',
        `account-users/${accountUserId}/contacts/search`
    )({...options, params}),

    getContacts: (
        accountUserId: string,
        params?: ListContactsParams,
        options?: ApiCallOptions
    ) => createApiCall<PaginatedResponse<ContactResource>>(
        SERVICE_NAMES.CONTACT,
        'GET',
        `account-users/${accountUserId}/contacts`
    )({...options, params}),

    getContact: (
        accountUserId: string,
        contactId: string,
        options?: ApiCallOptions
    ) => createApiCall<ContactResource>(
        SERVICE_NAMES.CONTACT,
        'GET',
        `account-users/${accountUserId}/contacts/${contactId}`
    )({...options}),

    createContact: (
        accountUserId: string,
        data: CreateContactRequest,
        options?: ApiCallOptions
    ) => createApiCall<ContactResource>(
        SERVICE_NAMES.CONTACT,
        'POST',
        `account-users/${accountUserId}/contacts`
    )({...options, data}),

    updateContact: (
        accountUserId: string,
        contactId: string,
        data: UpdateContactRequest,
        options?: ApiCallOptions
    ) => createApiCall<ContactResource>(
        SERVICE_NAMES.CONTACT,
        'PUT',
        `account-users/${accountUserId}/contacts/${contactId}`
    )({...options, data}),

    deleteContact: (
        accountUserId: string,
        contactId: string,
        options?: ApiCallOptions
    ) => createApiCall<void>(
        SERVICE_NAMES.CONTACT,
        'DELETE',
        `account-users/${accountUserId}/contacts/${contactId}`
    )({...options})
};
